var toString = {}.toString;

var getType = function getType(value) {
  return toString.call(value).replace(/^\[object /, '').replace(/\]$/, '');
};

module.exports = getType;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/type/get-type.js
// module id = 113
// module chunks = 0 1 2